import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#000000' cx='12' cy='12' r='12' />,
    <circle key='1' fill='#FFFFFF' cx='12' cy='12' r='10' />,
    <path
      key='2'
      fill='#000000'
      d='M16.1,8.7h-0.6V7.3c0-1.9-1.5-3.3-3.3-3.3S8.7,5.5,8.7,7.3v1.3H8c-0.7,0-1.3,0.6-1.3,1.3v6.7C6.6,17.4,7.3,18,8,18h8
	c0.7,0,1.3-0.6,1.3-1.3V10C17.4,9.3,16.8,8.7,16.1,8.7z M12,14.7c-0.7,0-1.3-0.6-1.3-1.3S11.3,12,12,12s1.3,0.6,1.3,1.3
	C13.4,14.1,12.8,14.7,12,14.7z M14.1,8.7H10V7.3c0-1.2,0.9-2.1,2.1-2.1s2.1,0.9,2.1,2.1V8.7z'
    />,
  ],
  'TransportConditionLockSecondary'
);

const TransportConditionLockSecondaryIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportConditionLockSecondaryIcon);
